// src/services/transportTouristiqueService.js
// Transport API service (version clean + CMI HTML)

import axios from "axios";

/**
 * ✅ Base serveur (sans /api)
 * CRA :  REACT_APP_API_BASE_URL=http://localhost:4000
 * Vite:  VITE_API_BASE_URL=http://localhost:4000
 */
const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  "https://nouzhaback-theta.vercel.app";

/**
 * ✅ Client JSON standard pour /api
 */
const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/**
 * ✅ Client CMI (retourne du HTML texte)
 */
const cmi = axios.create({
  baseURL: `${API_BASE}/api/cmi`,
  withCredentials: true,
  headers: { "Content-Type": "application/json", Accept: "text/html" },
  responseType: "text",
  transformResponse: [(r) => r], // IMPORTANT : garder le HTML brut
});

export const transportApi = {
  // ✅ (optionnel) récupérer TOUS les transports
  getAll: async (params = {}) => {
    const { data } = await api.get("/transports", { params });
    return data;
  },

  // ✅ récupérer les transports par catégorie
  // categorie: "trajet" | "navette_aeroport" | "mise_a_disposition"
  getByCategory: async (categorie, params = {}) => {
    const { data } = await api.get(`/transports/category/${categorie}`, {
      params,
    });
    return data;
  },

  // Trajets simples
  getTrajets: async (params = {}) => {
    const { data } = await api.get("/transports/trajets", { params });
    return data;
  },

  // Navettes aéroport
  getNavettes: async (params = {}) => {
    const { data } = await api.get("/transports/navettes", { params });
    return data;
  },

  // Mise à disposition
  getMiseADisposition: async (params = {}) => {
    const { data } = await api.get("/transports/disposition", { params });
    return data;
  },

  // Recherche trajets
  searchTrajets: async (searchParams) => {
    const { data } = await api.post("/transports/recherche/trajets", searchParams);
    return data;
  },

  // Recherche navettes
  searchNavettes: async (searchParams) => {
    const { data } = await api.post("/transports/recherche/navettes", searchParams);
    return data;
  },

  // ✅ Envoyer une demande (sans paiement)
  createTransportRequest: async (payload) => {
    const { data } = await api.post("/reservations/transports/request", payload);
    return data;
  },

  // ✅ Initier un paiement CMI transport (retour HTML)
  createCmiTransportPayment: async (paymentData) => {
    const html = await cmi.post("/transport/create", paymentData);
    return html.data; // string HTML
  },
};
